import Image from "next/image";
import localeCore from "../../core/locale.core";
import useAdminShop from "../../hooks/useAdminShop";
import { Media } from "../../types/media";

export default function ClientLogo() {
  const shop = useAdminShop();

  if (!shop) return null;
  const { width, height } = getComputedImageDimensions(50, shop.logoMedia);

  return (
    <div className="flex gap-3 items-center">
      <p>{localeCore.getLocaleValueDefault(shop.name)}</p>

      <Image height={height} width={width} alt="shop logo" src={shop.logoMedia?.url as string} unoptimized />
    </div>
  );
}

const getComputedImageDimensions = (height: number, media: Media) => {
  const width = Math.round((media.width / media.height) * height);

  return { width, height };
};
